<template>
  <div id="home" class="wrapper boxshadowcustom" style="padding-bottom: 1px">
    <div class="hero-particles-container" style="height: 100vh; z-index: 2">
      <canvas id="hero-particles"></canvas>
    </div>
    <!--intro-->

    <div class="gap"></div>
    <div class="gap"></div>
    <div class="gap"></div>
    <div class="gap"></div>
    <div class="gap"></div>

    <Titles :viewport="viewport" scene="curriculum">
      <div id="logo_1">
        <h1 class="title">
          <img src="../assets/img/Logo8i.png" alt="logo-8i" class="logo-class logo-resp" />
        </h1>

        <div v-if="data" class="std">
          <p class="-gray" v-if="data">
            {{ data.config.labels[0] }}
            <!-- {{ data.config.labels[Math.round(this.getRandomArbitrary(0, data.config.labels.length))] }} -->
          </p>
        </div>

        <div class="container-arrow-down">
          <img src="../assets/img/arrow_down.gif" alt="scroll" class="arrow-down" />
        </div>
      </div>
    </Titles>

    <!--biz commerce scenes-->

    <Biz :viewport="viewport" />
    <div class="gap"></div>
    <div id="quienes-somos"></div>

    <!--Title: Art Phi Games-->

    <Titles :viewport="viewport" scene="ArtPhiGamesTitle2">
      <vue-typed-js
        :strings="[
          'Intelligence',
          'Integración',
          'Innovación',
          'Infraestructura',
          'IT',
          'Soporte',
          'Servicio',
          'Desarrollo',
        ]"
        :loop="true"
        :typeSpeed="60"
        :backSpeed="25"
      >
        <h1 class="title title-c">
          <span class="line"
            ><span class="params"></span>8i: <span class="params fw-600"><span class="typing"></span></span
          ></span>
        </h1>
      </vue-typed-js>
    </Titles>

    <div id="servicios"></div>
    <Titles :viewport="viewport" scene="qsTitle">
      <section class="social-grid titulo-quienes-somos">
        <div class="container-b">
          <div class="row" style="width: 100%">
            <div class="col-lg-12 col-xl-1 fade-in-right visible" style="height: 100vh">
              <h2 class="title--2xl title--stroke title--stroke3 title--vertical">Nosotros</h2>
            </div>
            <div class="col-lg-12 col-xl-10" style="display: none">
              <div class="flex-grid flex-grid--social fade-in-up visible"></div>
            </div>
          </div>
        </div>
      </section>
    </Titles>

    <EarlyDays :viewport="viewport" />

    <div id="contactanos"></div>
  </div>
</template>

<script>
// style
import "@/styles/home.scss";
// ScrollMagic
import * as ScrollMagic from "scrollmagic";
// components
import Intro from "@/components/Home/Intro.vue";
import Titles from "@/components/Home/Titles.vue";
import Containers from "@/components/Home/Containers.vue";
import Biz from "@/components/Home/Biz.vue";
import EarlyDays from "@/components/Home/EarlyDays.vue";
import Ghibli from "@/components/Home/Ghibli.vue";
import Wrapper from "@/components/Home/Wrapper.vue";
import Thanks from "@/components/Home/Thanks.vue";
// loop animations (depend on each scene!!!)
// @TODO improve
import BizBiz from "@/js/abiz";
import BizAstro from "@/js/astro";
import BizCoffee from "@/js/coffee";
import BizET from "@/js/et";
import BizDino from "@/js/dino";
import BizFilomena from "@/js/filomena";
import BizOcto from "@/js/octo";
import BizZen from "@/js/zen";
import BizShapes from "@/js/shapes";
import axios from "axios";

export default {
  name: "home",
  components: {
    Intro,
    Titles,
    Containers,
    Biz,
    EarlyDays,
    Ghibli,
    Wrapper,
    Thanks,
  },
  props: {
    viewport: Object,
  },
  data() {
    return {
      intro: new TimelineMax(),
      scroller: new ScrollMagic.Controller(),
      scenes: [],
      timeLines: [],
      tweeners: [],
      data: null,
    };
  },
  created() {
    // before leaving the page, in case of refresh
    window.addEventListener("beforeunload", () => window.scroll(0, 0));
  },
  mounted() {
    // setTimeout(() => {
    this.getData();
    // }, 1000);

    this.heroParticles();
    this.formStep();
    // this.counters();
    this.tagCanvas();
    /**
     * @TODO code split animations
     *       optimize code
     *       better Mario commands
     */

    // 01. play Intro
    this.playIntro();
    // 02. setup time lines and scenes
    this.setupScenes();
    // 03. build loop animations for each character
    this.buildLoops();
    // 04. Hook loops to ScrollMagic Scenes
    this.hookLoops();
    // 05. Animate every scene on scroll
    this.sceneCurriculumVitae();

    this.sceneBizTitle();
    this.sceneBizZen();
    this.sceneBizEverybody();
    this.sceneBizEnding();

    this.sceneEarlyDays();

    this.sceneArtPhiGames();
    // this.sceneMario();
    // this.sceneGhibli();
    // </wrapper>
    this.sceneWrapper();
  },
  beforeDestroy() {
    // stop loop animations
    BizBiz.stop();
    BizAstro.stop();
    BizCoffee.stop();
    BizDino.stop();
    BizET.stop();
    BizFilomena.stop();
    BizOcto.stop();
    BizShapes.stop();
    BizZen.stop();

    // kill time lines
    this.timeLines.map((tl) => tl.kill());
    // destroy ScrollMagic controller
    this.scroller.destroy();
  },
  methods: {
    getData() {
      let url = "data.json"; //ANCHOR[id=ALL-DATA]

      return axios
        .get(url)
        .then((res) => {
          console.log(res);

          this.$nextTick(() => {
            this.data = res.data;
          });
        })
        .catch((error) => {
          console.log(error.response);
        });
    },
    getRandomArbitrary(min, max) {
      return Math.random() * (max - min) + min;
    },
    tagCanvas() {
      //  window.onload = function() {
      try {
        TagCanvas.Start("myCanvas", "tags", {
          wheelZoom: false,
          initial: [0.08, -0.0006],
          freezeActive: true,
          freezeDecel: true,
          noSelect: true,
          textColour: "#ffff",
          outlineColour: "#ff00ff",
          textHeight: 20,
          depth: 0.8,
          reverse: true,
          maxSpeed: 0.05,
          weightMode: "both",
          weight: true,
        });
      } catch (e) {
        // something went wrong, hide the canvas container
        document.getElementById("myCanvasContainer").style.display = "none";
      }
      // };
    },
    setupScenes() {
      /**
       * @desc
       * Where the magic happens
       *
       * add tweeners to the scenes,
       * then to the ScrollMagic controller,
       * and then the tweeners will tween the time lines.
       *
       * This way I can synchronize scenes to the HTML content
       * and keep the momentum effect on all browsers
       */
      const scenesElements = document.querySelectorAll(".scene");
      for (let [i, scenesElement] of Array.from(scenesElements).entries()) {
        // tweeners, to animate the time lines' progress, to add momentum
        this.tweeners[i] = new TimelineMax();
        // time lines
        this.timeLines[i] = new TimelineMax({ paused: true });
        // create scenes on ScrollMagic
        this.scenes[i] = new ScrollMagic.Scene({
          // trigger on the scene element
          triggerElement: scenesElement,
          // start half screen before
          offset: -this.viewport.h / 2,
          // lasts for the scene element height
          duration: scenesElement.offsetHeight,
        })
          .setTween(this.tweeners[i])
          .addTo(this.scroller)
          .reverse(true)
          .setClassToggle(scenesElement, "active");
        // animate the progress in the time lines
        this.tweeners[i]
          .to(scenesElement, 1, { autoAlpha: 1 }) // fake, just to have some progress
          .eventCallback("onUpdate", (event) => {
            TweenLite.to(this.timeLines[i], 0.5, {
              progress: this.tweeners[i].progress(),
              ease: Power0.easeNone,
            });
          });
      }
    },
    playIntro() {
      /**
       * @desc
       * intro scene
       */
      //   this.sceneCurriculumVitae();
      this.intro
        .set("#curriculum .title-container", { autoAlpha: 1 }) // show animations
        .addLabel("start", 0)
        //  .set('.hero-particles-container', {autoAlpha: 1})
        .from(
          "#curriculum .title",
          2,
          {
            yPercent: -50,
            autoAlpha: 0,
            rotationX: 90,
            transformOrigin: "50% 50% -100px",
            ease: Power3.easeOut,
          },
          "start"
        )
        .from(
          "#curriculum .std",
          2,
          {
            yPercent: 50,
            autoAlpha: 0,
            rotationX: -90,
            transformOrigin: "50% 50% -100px",
            ease: Power3.easeOut,
          },
          "start"
        )
        .set(".arrow-down", { autoAlpha: 1 });
    },
    hookLoops() {
      /**
       * @desc
       * play and stop loop animations
       * based on the scenes been played
       */
      this.scenes[0]
        .on("enter", (e) => {
          if (e.scrollDirection === "FORWARD") {
          }
          if (e.scrollDirection === "REVERSE") {
            BizBiz.stop();
            BizShapes.stop();
            $("#logo_1").removeClass("hidden-element");
            $(".arrow-down").removeClass("hidden-element");
          }
        })
        .on("leave", (e) => {
          if (e.scrollDirection === "FORWARD") {
            $("#logo_1").addClass("hidden-element");
            $(".arrow-down").addClass("hidden-element");
          }
        });
      this.scenes[1].on("enter", (e) => {
        if (e.scrollDirection === "FORWARD") {
          BizBiz.play();
          BizShapes.play();
        }
        if (e.scrollDirection === "REVERSE") {
          BizZen.stop();
        }
      });
      this.scenes[2]
        .on("enter", (e) => {
          if (e.scrollDirection === "FORWARD") {
            BizZen.play();
          }
          if (e.scrollDirection === "REVERSE") {
            $("#myCanvasContainer").removeClass("hidden-element");
            BizBiz.play();
            BizShapes.play();

            BizFilomena.stop();
            BizDino.stop();
            BizET.stop();
            BizOcto.stop();
            BizAstro.stop();
            BizCoffee.stop();
          }
        })
        .on("leave", (e) => {
          if (e.scrollDirection === "FORWARD") {
            $("#myCanvasContainer").addClass("hidden-element");
          }
        });
      this.scenes[3]
        .on("enter", (e) => {
          $(".planet-img").removeClass("hidden-element");
          document.body.classList.add("-desbravando-bg");
          if (e.scrollDirection === "FORWARD") {
            BizBiz.stop();
            BizShapes.stop();

            BizFilomena.play();
            BizDino.play();
            BizET.play();
            BizOcto.play();
            BizAstro.play();
            BizCoffee.play();
          }
          if (e.scrollDirection === "REVERSE") {
            BizZen.play();
          }
        })
        .on("leave", (e) => {
          if (e.scrollDirection === "REVERSE") {
            document.body.classList.remove("-desbravando-bg");
          }

          if (e.scrollDirection === "FORWARD") {
            $(".planet-img").addClass("hidden-element");
          }
        });
      this.scenes[4].on("enter", (e) => {
        if (e.scrollDirection === "FORWARD") {
          BizZen.stop();
        }
        if (e.scrollDirection === "REVERSE") {
          BizFilomena.play();
          BizDino.play();
          BizET.play();
          BizOcto.play();
        }
      });
      this.scenes[5]
        .on("enter", (e) => {
          if (e.scrollDirection === "FORWARD") {
            BizFilomena.stop();
            BizDino.stop();
            BizET.stop();
            BizOcto.stop();
          }
          if (e.scrollDirection === "REVERSE") {
            document.body.classList.add("-desbravando-bg");
            BizAstro.play();
            BizCoffee.play();
          }
        })
        .on("leave", (e) => {
          if (e.scrollDirection === "FORWARD") {
          }
        });
      this.scenes[6]
        .on("enter", (e) => {
          if (e.scrollDirection === "FORWARD") {
          }
          if (e.scrollDirection === "REVERSE") {
          }
        })
        .on("leave", (e) => {
          if (e.scrollDirection === "FORWARD") {
          }
          if (e.scrollDirection === "REVERSE") {
          }
        });
      this.scenes[7].on("enter", (e) => {
        if (e.scrollDirection === "FORWARD") {
        }
        if (e.scrollDirection === "REVERSE") {
        }
      });
      // 7
      // 8
      this.scenes[9]
        .on("enter", (e) => {
          if (e.scrollDirection === "FORWARD") {
          }
          if (e.scrollDirection === "REVERSE") {
          }
        })
        .on("leave", (e) => {});
      this.scenes[10] /** @Mario **/
        .on("enter", (e) => {
          if (e.scrollDirection === "FORWARD") {
          }
          if (e.scrollDirection === "REVERSE") {
          }
        })
        .on("leave", (e) => {
          if (e.scrollDirection === "FORWARD") {
          }
          if (e.scrollDirection === "REVERSE") {
          }
        });
    },
    buildLoops() {
      /**
       * @desc
       * mount loop animations
       */

      if (this.viewport.is568) {
        // Castle.build568();
      } else {
        // Castle.build();
      }
      if (this.viewport.is568) {
        // Pepe.build568();
      } else if (this.viewport.is1024) {
        // Pepe.build1024();
      } else {
        // Pepe.build();
      }
      if (!this.viewport.is1024) {
        // BizFilomena.build();
        // BizOcto.build();
      }
    },
    sceneCurriculumVitae() {
      /**
       * @desc
       * Scrolling animations time lines
       */
      this.timeLines[0]
        .to("#curriculum .title, #curriculum .std", 2, {
          autoAlpha: 0,
          yPercent: -100,
        })

        .to(".hero-particles-container", 2, {
          autoAlpha: 1,
        })
        .to("#curriculum .arrow-down", 2, {
          autoAlpha: 0,
        })
        .to("#logo-parte2", 3, {
          autoAlpha: 0,
        });
    },
    sceneBizTitle() {
      // biz()
      this.timeLines[1]
        // next scene characters
        .set("#filomena", {
          autoAlpha: 0,
          scale: 0,
          xPercent: 600,
          yPercent: 100,
        })
        .set("#dino", {
          scale: 0,
          xPercent: 400,
          yPercent: 100,
        })
        .set("#astro, #coffee, #et, #octo", {
          autoAlpha: 0,
          scale: 0,
          xPercent: 400,
          yPercent: 100,
        })
        // this scene
        .set("#bizTitle .title-container, #biz1 .container", { autoAlpha: 1 })
        .addLabel("start", 0)
        .fromTo("#zen2", 3.7, { y: "+=90" }, { y: 0, autoAlpha: 1, ease: Power1.easeOut }, "+=1.4")
        .from(
          "#bizTitle .title",
          6,
          {
            yPercent: -50,
            autoAlpha: 0,
            rotationX: 90,
            transformOrigin: "50% 50% -100px",
            ease: Power3.easeOut,
          },
          "start"
        )

        .staggerFrom(
          "#smart, #open",
          6,
          {
            autoAlpha: 0,
            scale: 0,
            ease: Power3.easeOut,
          },
          0.2,
          "start+=2"
        )

        .fromTo(
          "#biz1 #tag-canvas",
          6,
          { y: "+=0", x: "0", scale: 0, autoAlpha: 0 },
          { y: 0, x: 0, autoAlpha: 1, ease: Power1.easeOut, scale: 1 },
          "start+=2"
        );
    },
    sceneBizZen() {
      // Biz Commerce 1
      this.timeLines[2]
        .to("#biz1 #tag-canvas", 5, {
          autoAlpha: 0,
        })

        .to("#zen2", 4, {
          yPercent: +20,
          autoAlpha: 0,
        })

        .to("#bizTitle .title", 8, {
          yPercent: +460,
          scale: 8.5,
        });
    },
    sceneBizEverybody() {
      // Biz Commerce 2
      this.timeLines[3]
        .addLabel("start", 0)
        // TITULO QUIENES SOMOS
        .to("#qsTitle .title-container", 3, { autoAlpha: 1 })
        .staggerFrom("#qsTitle .titulo-quienes-somos", 5, {
          yPercent: -50,
          autoAlpha: 0,
          rotationX: 0,
          transformOrigin: "50% 50% -100px",
          ease: Power3.easeOut,
          stagger: 0.5,
        });
    },
    sceneBizEnding() {
      // Biz Commerce 3
      this.timeLines[4]
        .addLabel("start", 0)
        .to("#earlyTitle .title-container", 2, { autoAlpha: 1 }, "start")
        .from(
          "#earlyTitle .title",
          4,
          {
            yPercent: -50,
            autoAlpha: 0,
            rotationX: 90,
            transformOrigin: "50% 50% -100px",
            ease: Power3.easeOut,
          },
          "start"
        )
        .to(
          "#earlyTitle .title, #earlyTitle .std, #earlyTitle .menu__container, #earlyTitle .div-column",
          6,
          {
            yPercent: -110,
            autoAlpha: 0,
          }
        )

        .to("#earlyTitle .menu__container", 6, {
          yPercent: -110,
          autoAlpha: 0,
        })
        .to("#earlyTitle .title", 6, {
          yPercent: -110,
          autoAlpha: 0,
        })

        .to("#bizTitle .title", 6, {
          autoAlpha: 0,
        })

        .to("#earlyTitle .title-container", 6, {
          autoAlpha: 0,
        })

        .to("#qsTitle .titulo-quienes-somos", 6, {
          yPercent: -110,
          autoAlpha: 0,
        });
    },
    sceneEarlyDays() {
      this.timeLines[5].addLabel("start", 0);
    },
    sceneOcean() {},
    sceneFloatingHead() {},
    sceneSunset() {},
    sceneArtPhiGames() {},
    sceneMario() {},
    sceneGhibli() {},
    sceneWrapper() {},

    galleryHome() {
      var modalInfo = {
        1: {
          title: "Desarrollo de Software",
          info: "...",
          link: "#",
          github: "#",
        },
        2: {
          title: "Arquitectura de Sistemas",
          info: "...",
          link: "#",
          github: "#",
        },
        3: {
          title: "Integración de sistemas",
          info: "...",
          link: "#",
          github: "#",
        },
        4: {
          title: "Ciberseguridad",
          info:
            "'<ul><li>Continuos Vulnerability Monitoring</li><li>Web Stress</li><li>Distributed Denia l of Service</li><li>Ethical Hacking</li><li>Incident response</li><li>Endpoint Management</li> <li>Dark Web monitoring</li><li>Secure configuration reviews</li><li>Secure Code Reviews</li>  <li>Administración de usuarios Multiplataforma</li></ul>'",
          link: "#",
          github: "#",
        },
        5: {
          title: "Soporte TI ",
          info: "....",

          //   link: "#",
          //   github: "#",
        },
        6: {
          title: "Project 6",
          info: "...",
          link: "#",
          github: "#",
        },
        7: {
          title: "Project 7",
          info: "...",
          link: "#",
          github: "#",
        },
        8: {
          title: "Project 8",
          info: "...",
          link: "#",
          github: "#",
        },
      };

      // Get the modal
      var modal = document.getElementById("preview");

      // button that opens the modal
      var btn = document.getElementsByClassName("button");

      // <span> that closes the modal
      var span = document.getElementsByClassName("close")[0];

      // open modal
      for (let i = 0; i < btn.length; i++) {
        btn[i].addEventListener("click", function () {
          var project = btn[i].parentElement;
          openModal(project);
        });
      }

      function openModal(project) {
        var id = project.id;
        var img = project.getElementsByTagName("img")[0].src;
        fillOut(id, img);
        modal.style.display = "block";
        document.getElementsByClassName("modal-content")[0].classList.add("scale");
      }

      function fillOut(id, img) {
        document.getElementById("title").innerHTML = modalInfo[id].title;
        document.getElementById("info").innerHTML = modalInfo[id].info;
        document.getElementById("img").src = img;
        document.getElementById("live").onclick = function () {
          window.open(modalInfo[id].link, "_blank");
        };
        document.getElementById("github").onclick = function () {
          window.open(modalInfo[id].github, "_blank");
        };
      }

      // close the modal
      span.onclick = function () {
        modal.style.display = "none";
      };

      window.onclick = function (event) {
        if (event.target == modal) {
          modal.style.display = "none";
        }
      };
    },

    counters() {
      const counters = document.querySelectorAll(".counter");

      counters.forEach((counter) => {
        counter.innerText = "0";
        const updateCounter = () => {
          const target = +counter.getAttribute("data-target");
          const count = +counter.innerText;
          const increment = target / 200;
          if (count < target) {
            counter.innerText = `${Math.ceil(count + increment)}`;
            setTimeout(updateCounter, 1);
          } else counter.innerText = target;
        };
        updateCounter();
      });
    },

    formStep() {
      var $input = $("input");
      var $textField;
      var $groupParent;

      $input
        .on("focus", function () {
          $groupParent = $(this).closest(".group");
          $textField = $groupParent.find(".text-field");

          $groupParent.addClass("active");
          $textField.addClass("filled focused");
        })
        .on("blur", function () {
          $textField.removeClass("focused");
          $groupParent.removeClass("active");

          if (this.value === "") {
            $textField.removeClass("filled");
          }
        });
    },

    heroParticles() {
      // Particle animation
      let Bubble = function (parentNode) {
        let self = this;
        self.parentNode = parentNode;
        self.getCanvasSize();
        window.addEventListener("resize", function () {
          self.getCanvasSize();
        });
        self.mouseX = 0;
        self.mouseY = 0;
        window.addEventListener("mousemove", function (e) {
          self.mouseX = e.clientX;
          self.mouseY = e.clientY;
        });
        self.randomise();
      };

      Bubble.prototype.getCanvasSize = function () {
        let self = this;
        self.canvasWidth = self.parentNode.clientWidth;
        self.canvasHeight = self.parentNode.clientHeight;
      };

      Bubble.prototype.generateDecimalBetween = function (min, max) {
        return (Math.random() * (min - max) + max).toFixed(2);
      };

      Bubble.prototype.update = function () {
        let self = this;
        self.translateX = self.translateX - self.movementX;
        self.translateY = self.translateY - self.movementY;
        self.posX += (self.mouseX / (self.staticity / self.magnetism) - self.posX) / self.smoothFactor;
        self.posY += (self.mouseY / (self.staticity / self.magnetism) - self.posY) / self.smoothFactor;

        if (
          self.translateY + self.posY < 0 ||
          self.translateX + self.posX < 0 ||
          self.translateX + self.posX > self.canvasWidth
        ) {
          self.randomise();
          self.translateY = self.canvasHeight;
        }
      };

      Bubble.prototype.randomise = function () {
        let self = this;
        self.colors = [
          "85,107,139",
          "38,141,247",
          "66,52,248",
          "255,108,80",
          "243, 244, 255",
          "96, 100, 131",
        ];
        self.velocity = 30; // Bubble levitation velocity (the higher the slower)
        self.smoothFactor = 50; // The higher, the smoother
        self.staticity = 30; // Increase value to make bubbles move slower on mousemove
        self.magnetism = 0.1 + Math.random() * 4;
        self.color = self.colors[Math.floor(Math.random() * self.colors.length)];
        self.alpha = self.generateDecimalBetween(5, 10) / 10;
        self.size = self.generateDecimalBetween(1, 4);
        self.posX = 0;
        self.posY = 0;
        self.movementX = self.generateDecimalBetween(-2, 2) / self.velocity;
        self.movementY = self.generateDecimalBetween(1, 20) / self.velocity;
        self.translateX = self.generateDecimalBetween(0, self.canvasWidth);
        self.translateY = self.generateDecimalBetween(0, self.canvasHeight);
      };

      let Background = function (selector) {
        let self = this;
        self.canvas = document.getElementById(selector);
        self.ctx = this.canvas.getContext("2d");
        self.dpr = window.devicePixelRatio;
      };

      Background.prototype.start = function () {
        let self = this;
        self.canvasSize();
        window.addEventListener("resize", function () {
          self.canvasSize();
        });
        self.bubblesList = [];
        self.generateBubbles();
        self.animate();
      };

      Background.prototype.canvasSize = function () {
        let self = this;
        self.container = self.canvas.parentNode;
        // Determine window width and height
        self.w = self.container.offsetWidth;
        self.h = self.container.offsetHeight;
        self.wdpi = self.w * self.dpr;
        self.hdpi = self.h * self.dpr;
        // Set canvas width and height
        self.canvas.width = self.wdpi;
        self.canvas.height = self.hdpi;
        // Set width and height attributes
        self.canvas.style.width = self.w + "px";
        self.canvas.style.height = self.h + "px";
        // Scale down canvas
        self.ctx.scale(self.dpr, self.dpr);
      };

      Background.prototype.animate = function () {
        let self = this;
        self.ctx.clearRect(0, 0, self.canvas.clientWidth, self.canvas.clientHeight);
        self.bubblesList.forEach(function (bubble) {
          bubble.update();
          self.ctx.translate(bubble.translateX, bubble.translateY);
          self.ctx.beginPath();
          self.ctx.arc(bubble.posX, bubble.posY, bubble.size, 0, 2 * Math.PI);
          self.ctx.fillStyle = "rgba(" + bubble.color + "," + bubble.alpha + ")";
          self.ctx.fill();
          self.ctx.setTransform(self.dpr, 0, 0, self.dpr, 0, 0);
        });
        /* global requestAnimationFrame */
        requestAnimationFrame(this.animate.bind(this));
      };

      Background.prototype.addBubble = function (bubble) {
        return this.bubblesList.push(bubble);
      };

      Background.prototype.generateBubbles = function () {
        let self = this;
        for (let i = 0; i < self.bubbleDensity(); i++) {
          self.addBubble(new Bubble(self.canvas.parentNode));
        }
      };

      Background.prototype.bubbleDensity = function () {
        return 15;
      };

      window.addEventListener("load", function () {
        const heroParticles = new Background("hero-particles");
        // const footerParticles = new Background('footer-particles')
        heroParticles.start();
      });
    },
  },
};
</script>
